import React, { useContext } from 'react';
import useWorkerService from '../../../app/services/hooks/useWorkerService';
import ActiveControl from '../../../components/ActiveControl';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import { AppContext } from '../../../contexts/AppContext';
import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';

interface Props {
    WorkerId: number;
    checkValue: boolean;
    callbackSuccess: () => void;
}

const WorkerSwitchChange = ({ WorkerId, checkValue, callbackSuccess }: Props) => {
    const [checked, setChecked] = React.useState<boolean>(checkValue);

    const { showLoading, hideLoading, changeAnimation } = useContext(AppContext);
    const { activeWorker, fetchingActiveWorker } = useWorkerService();

    const active = (value: boolean) => {
        setChecked(value);

        activeWorker(WorkerId, value, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                useReactConfirmAlert().successAlert({
                    title: 'Éxito',
                    message: response.message
                });

                callbackSuccess();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                setChecked(!value);
                useReactConfirmAlert().errorAlert({
                    title: 'Error',
                    message: response.message
                });
            }
        });
    };

    return <ActiveControl status={checked} id={WorkerId} callback={active} />;
};

export default WorkerSwitchChange;
